<div class="modal-header">
  <h4 class="modal-title">{{ 'INDUSTRIES.INDUSTRIES_SEO_FORM.EDIT' | translate }} - {{ industrySeo?.name }}</h4>
  <button type="button" class="close btn-close-templates" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body p-0 d-flex flex-column">
  <form
    id="industry-seo-form"
    (ngSubmit)="save()"
    [formGroup]="form"
    novalidate
    class="d-flex overflow-hidden flex-grow-1"
  >
    <ng-scrollbar class="locales-menu ps">
      <div class="modal-section-title mt-2 mb-2 ps-2">
        {{ 'INDUSTRIES.INDUSTRIES_SEO_FORM.WEBSITES_LIST_TITLE' | translate }}
      </div>

      <div
        *ngFor="let websiteLocale of companyWebsiteLocales"
        (click)="selectCompanyWebSiteLocale(websiteLocale.id)"
        class="website-locale d-flex"
        [ngClass]="{ active: currentWebsiteLocaleId === websiteLocale.id }"
      >
        <div class="ico">
          <i class="fal fa-chevron-right"></i>
        </div>
        <div class="name">{{ websiteLocale.website.name }} - {{ websiteLocale.website.url }}</div>
        <div class="flag">
          <span class="flag-icon" [ngClass]="'flag-icon-' + websiteLocale.locale.locale"></span>
        </div>
      </div>
    </ng-scrollbar>

    <div class="flex-grow-1 overflow-auto">
      <div class="locales-content-wrapper" formArrayName="websiteLocales">
        <div *ngIf="!currentWebsiteLocaleId" class="modal-section-title ps-3 mt-2">
          {{ 'INDUSTRIES.INDUSTRIES_SEO_FORM.SELECT_WEBSITE_MSG' | translate }}
        </div>

        <div *ngFor="let websiteLocale of form.get('websiteLocales')?.controls; let i = index" class="locales-content">
          <div
            [formGroupName]="i"
            *ngIf="currentWebsiteLocaleId === websiteLocale.get('company_website_locale_id').value"
          >
            <div class="modal-section-title mt-2 mb-2">
              {{ getWebsiteLocaleName(websiteLocale.get('company_website_locale_id').value) }}
            </div>

            <div class="form-group">
              <label>{{ 'INDUSTRIES.INDUSTRIES_SEO_FORM.NAME' | translate }}</label>
              <input type="text" class="form-control" formControlName="name" />
            </div>

            <div class="form-group">
              <label>{{ 'INDUSTRIES.INDUSTRIES_SEO_FORM.DESCRIPTION' | translate }}</label>
              <editor
                formControlName="description"
                [init]="{
                  plugins: 'table link autoresize',
                  base_url: '/assets/tinymce',
                  suffix: '.min',
                  height: 400
                }"
              ></editor>
            </div>

            <div class="form-group">
              <label>{{ 'INDUSTRIES.INDUSTRIES_SEO_FORM.SLUG' | translate }}</label>
              <input type="text" class="form-control" formControlName="slug" />
            </div>

            <div class="form-group">
              <label>{{ 'INDUSTRIES.INDUSTRIES_SEO_FORM.META_TITLE' | translate }}</label>
              <input type="text" class="form-control" formControlName="meta_title" />
            </div>

            <div class="form-group">
              <label>{{ 'INDUSTRIES.INDUSTRIES_SEO_FORM.META_DESCRIPTION' | translate }}</label>
              <input type="text" class="form-control" formControlName="meta_description" />
            </div>

            <div class="d-flex">
              <div class="custom-control custom-checkbox me-3">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  formControlName="active"
                  [attr.id]="'industries-seo-form-active' + i"
                />
                <label class="custom-control-label" [attr.for]="'industries-seo-form-active' + i">
                  {{ 'INDUSTRIES.INDUSTRIES_SEO_FORM.ACTIVE' | translate }}
                </label>
              </div>
            </div>
            <div class="d-flex">
              <div class="custom-control custom-checkbox me-3">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  formControlName="top"
                  [attr.id]="'industries-seo-form-top' + i"
                />
                <label class="custom-control-label" [attr.for]="'industries-seo-form-top' + i">
                  {{ 'INDUSTRIES.INDUSTRIES_SEO_FORM.TOP' | translate }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="submit" class="btn btn-outline-dark btn-xs" form="industry-seo-form" [disabled]="form.invalid">
    {{ 'INDUSTRIES.INDUSTRIES_SEO_FORM.SAVE' | translate }}
  </button>
</div>
